import { render, staticRenderFns } from "./ItemTableOtherPlatformComponent.vue?vue&type=template&id=347abb08&scoped=true&"
import script from "./ItemTableOtherPlatformComponent.vue?vue&type=script&lang=js&"
export * from "./ItemTableOtherPlatformComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347abb08",
  null
  
)

export default component.exports